import { SKELETON_STYLES } from '../lib/constants';

const CategoryItemSkeleton = () => {
  return (
    <div className='flex min-h-[88px] w-full flex-col items-center justify-center gap-[12px] rounded-[8px] p-[8px] sm:min-h-[108px]'>
      <div className={SKELETON_STYLES.ICON_CONTAINER} />
      <div className={SKELETON_STYLES.NAME_PLACEHOLDER} />
    </div>
  );
};

export default CategoryItemSkeleton;
